/* eslint-disable no-param-reassign */
import SET_LANG from './types';

export default {
  [SET_LANG](state, locale) {
    if (state.locales.indexOf(locale) !== -1) {
      state.locale = locale;
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/i18n/mutations.js